/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Tenant-configurable property link destinations, in evaluation order.
 */
export enum PropertySharingDestination {
    COMOS = 'comos',
    EXTERNAL = 'external',
    SOURCE = 'source',
}
